// Finar rev. madde 12 (2026-10-30) — Veri Kataloğu KATEGORİ düğümü tanımı (tek kaynak, FE + BE).
// Kategori = global (clientId NULL) düğüm ∧ grup düğümü değil ∧ (saklı `nodeKind='category'` ∨ kök
// ∨ en az bir GRUP DIŞI alt düğümü var). Kök düğümler katalog sekmeleridir (Çevresel/Sosyal…);
// grup dışı çocuğu olan düğüm ara kategoridir (0069 öncesi veri de böyle — koşulsuz backfill).
// Kırılım (0069): grup düğümü (`breakdown_group`) hiçbir zaman kategori değildir; yalnız grup
// çocuklu metrik (kırılımlı TOPLAM) de kategori değildir — grup/üye bir gösterge ayrıntısıdır.
// Müşteriye özel düğümler (clientId dolu) global kataloğun parçası değildir → kategori sayılmaz.
// Kategori işlemleri `kpi.catalog.categories` izni ister (yalnız Sistem Yöneticisi).

export interface KpiCatalogNodeRef {
  id: string;
  parentId: string | null;
  clientId: string | null;
  /** 0069 saklanan düğüm türü; yoksa `metric` (eski DTO/fixture). */
  nodeKind?: string | undefined;
}

/**
 * Düğüm global katalogda kategori mi? `childCount` = düğümün (her kapsamdan) GRUP DIŞI alt düğüm
 * sayısı (`kpiCatalogChildCounts` böyle sayar).
 */
export function isKpiCatalogCategory(node: KpiCatalogNodeRef, childCount: number): boolean {
  if (node.clientId !== null || node.nodeKind === "breakdown_group") return false;
  return node.nodeKind === "category" || node.parentId === null || childCount > 0;
}

/** Listeden grup dışı alt düğüm sayıları (parentId → n); grup düğümleri sayılmaz. */
export function kpiCatalogChildCounts(nodes: readonly KpiCatalogNodeRef[]): Map<string, number> {
  const counts = new Map<string, number>();
  for (const n of nodes) {
    if (n.parentId && n.nodeKind !== "breakdown_group") {
      counts.set(n.parentId, (counts.get(n.parentId) ?? 0) + 1);
    }
  }
  return counts;
}

/** Liste içindeki kategori düğümlerinin id kümesi. */
export function kpiCatalogCategoryIds(nodes: readonly KpiCatalogNodeRef[]): Set<string> {
  const counts = kpiCatalogChildCounts(nodes);
  return new Set(
    nodes.filter((n) => isKpiCatalogCategory(n, counts.get(n.id) ?? 0)).map((n) => n.id),
  );
}
